import { FontSize, GridColumn } from '@store/types/UserStoreSlice.type';
import { OfferingThemeMode } from '@store/types/UserStoreSlice.type';

export const PREFERENCE_CONFIGS = {
  offeringGridColumns: {
    key: 'offeringGridColumns' as const,
    label: 'Fields per column',
    testId: 'radio-group-field-grid-columns',
    options: [
      { value: GridColumn.OFFERING_DEFAULT, label: 'Offering Default' },
      { value: GridColumn.SINGLE_COLUMN, label: 'Single Column' },
      { value: GridColumn.TWO_COLUMN, label: 'Two Columns' },
    ],
  },
  fontSize: {
    key: 'fontSize' as const,
    label: 'Font Size',
    testId: 'radio-group-field-font-size',
    options: [
      { value: FontSize.SMALL, label: 'Smaller' },
      { value: FontSize.DEFAULT, label: 'Default' },
      { value: FontSize.LARGE, label: 'Large' },
      { value: FontSize.EXTRA_LARGE, label: 'Extra Large' },
    ],
  },
  offeringColorMode: {
    key: 'offeringColorMode' as const,
    label: 'Theme',
    testId: 'radio-group-field-theme',
    options: [
      { value: OfferingThemeMode.DEFAULT, label: 'LIO Default' },
      { value: OfferingThemeMode.DARK, label: 'Dark' },
    ],
  },
};
